import { Component, Input, OnInit } from '@angular/core';
import ICalibrationSetAttribute = ZoneIQCalibration.ICalibrationSetAttribute;

@Component({
    standalone: false,
    selector: 'ziq-assumption-component',
    templateUrl: './assumption-component.component.html',
    styleUrls: ['./assumption-component.component.scss']

})
export class AssumptionComponentComponent implements OnInit {

    @Input()
    assumption: ICalibrationSetAttribute

    constructor() { }

    ngOnInit() { }
}
